import type {
  ExperimentConfig,
  FeatureType,
} from '@seek/candidate-feature-flag';

export const APPLICANT_INSIGHTS_NUMBER_OF_APPLICANTS_FEATURE_FLAG =
  'experiment-applicant-insights-number-of-applicants-jdv';
const applicationInsightNumberOfApplicantsExperiment = {
  key: APPLICANT_INSIGHTS_NUMBER_OF_APPLICANTS_FEATURE_FLAG,
  trackingNumber: 74,
  title: 'Applicant Insights Number Of Applicants',
  type: 'string',
  variations: ['control', 'count', 'volume'] as const,
} satisfies ExperimentConfig;
export type ApplicantInsightNumberOfApplicantsExperiment = FeatureType<
  typeof applicationInsightNumberOfApplicantsExperiment
>;

export const BEHAVIOURAL_CUES_FILTERS_FEATURE_FLAG =
  'experiment-behavioural-cues-filters';
export const BehaviouralCuesFilters = 'bcuesFilters';
const behaviouralCuesFiltersExperiment = {
  key: BEHAVIOURAL_CUES_FILTERS_FEATURE_FLAG,
  trackingNumber: 65,
  title: 'Behavioural Cues Filters',
  type: 'string',
  variations: ['control', BehaviouralCuesFilters] as const,
} satisfies ExperimentConfig;
export type BehaviouralCuesFiltersExperiment = FeatureType<
  typeof behaviouralCuesFiltersExperiment
>;

export const experimentsToFetch: ExperimentConfig[] = [
  applicationInsightNumberOfApplicantsExperiment,
  behaviouralCuesFiltersExperiment,
];
